/* The fund ledger's reads (see ledgerWords.ts for the shape and words). */

import { apiFetch } from '../lib/api'
import type { FundLedger, FundLedgerList } from './ledgerWords'

export type * from './ledgerWords'

/* `background`: a heartbeat re-fetch, not the officer — never moves the
 * idle clock (lib/api.ts). */
export function fetchFundLedger(fundRef: string, background = false): Promise<FundLedger> {
  return apiFetch<FundLedger>(`/api/funds/${encodeURIComponent(fundRef)}/ledger`, {
    background,
  })
}

/** Every visible fund's ledger in one sweep (the Funds list, the
 *  Workbench tiles and chips, the queue headers). */
export function fetchFundLedgers(background = false): Promise<FundLedgerList> {
  return apiFetch<FundLedgerList>('/api/funds/ledger', { background })
}
